import { PRICE_PLAN_SOC_TYPE, UnlimThreeStatus } from 'constants/accumulators';
import { AccumItemType, AccumServiceType } from 'types/accumulators';

export const isAdditional = (accumulator: AccumItemType) => {
  return accumulator?.socType ?
      accumulator.socType.toLowerCase() !== PRICE_PLAN_SOC_TYPE.toLowerCase()
    : true;
};

export const excludeGiftAccumulators = (accumulators: AccumItemType[] = []) => {
  return accumulators.filter((acc) => !acc.isGiftBucket);
};

export const replaceDotWithComma = (restValue: number) => String(restValue).replace('.', ',');

export const formatTimeUnit = (unit: string) => {
  const timeUnit = ['минута', 'минуты', 'минут'];

  if (timeUnit.includes(unit)) {
    return 'мин';
  }

  return unit;
};

export const composeUnit = (restValue: number, unit: string, isUnlimited?: boolean) =>
  `${isUnlimited ? '' : replaceDotWithComma(restValue)} ${formatTimeUnit(unit)}`.trim();

export const getUnit = (responseUnit: string) => {
  if (responseUnit.toLocaleLowerCase() === 'sms') {
    return 'смс';
  }

  return responseUnit.toLocaleLowerCase();
};

export const getMainTextVariant = (isInline: boolean, isMobile: boolean) => {
  if (isInline) {
    return isMobile ? 'caption-medium' : 'body-paragraph-small';
  }

  return isMobile ? 'body-small' : 'body-medium';
};

export const getSecondaryTextVariant = (isMobile: boolean) => {
  return isMobile ? 'caption-medium' : 'body-paragraph-small';
};

export const getTextColor = (isLow: boolean) => {
  return isLow ? 'error' : 'primary';
};

export const getMainTextColor = (isLow?: boolean) => {
  return isLow ? 'error' : 'primary';
};

export const getTextColorForGiftedAccumulator = (rest: number) => {
  return rest === 0 ? 'tertiary' : 'primary';
};

export const dispatchHideGiftAccumulatorEvent = () => {
  if (window?.location?.href.indexOf('elk') > -1) {
    const customEvent = new CustomEvent<boolean>('showGiftAccumulator', {
      detail: false,
    });
    window?.dispatchEvent(customEvent);
  }
};

export const getUnlimitedActiveEnabled = ({
  isStandardUnlimited,
  isTariffDivideEnabled,
  isElkUnlimAccum3HoursEnabled,
  services,
}: {
  isElkUnlimAccum3HoursEnabled: boolean;
  isStandardUnlimited: boolean;
  isTariffDivideEnabled: boolean;
  services?: AccumServiceType;
}) =>
  isStandardUnlimited &&
  isTariffDivideEnabled &&
  isElkUnlimAccum3HoursEnabled &&
  services?.unlimited3?.status === UnlimThreeStatus.ACTIVE &&
  !!services?.unlimited3?.expirationDate;
